import { create } from 'zustand'
import { io, Socket } from 'socket.io-client'

import { ExitModellingDataModel } from './InvestmentModellingHelper'

export type IMState = {
  IMData: ExitModellingDataModel
  setIMData: (data: ExitModellingDataModel) => void
  connect: () => void
  sendMessage: (message: ExitModellingDataModel) => void
  disconnect: () => void
  reset: (data: ExitModellingDataModel) => void
  resetData: () => void
}

const exitModellinginitialState = {
  IMData: {
    finalHoldingPercentage: 0,
    numberOfRounds: 0,
    dilutionPerRound: 0,
    finalInvestmentAmount: 0,
    currentInvestmentDetails: {
      dilution: 0,
      valuation: 0,
      investment: 0,
      holdingPercentage: 0,
      date: '',
      roundSize: 0,
      revenue: 0,
      exitHere: true,
      currentValue: 0,
    },
    tableDetails: [],
    heatMap: [],
    nonPriceRoundHeatMap: [],
    valuationCap: 0,
    companyFdbShares: 0,
    finalCurrentValue: 0,
  },
}

function updateCalculatedValues(prevModelling: ExitModellingDataModel, newModellingData: ExitModellingDataModel) {
  if (prevModelling.tableDetails.length === newModellingData.tableDetails.length) {
    const newTableDetails = prevModelling.tableDetails.map((table, index) => ({
      ...table,
      investment: newModellingData.tableDetails[index].investment,
      holdingPercentage: newModellingData.tableDetails[index].holdingPercentage,
      roundSize: newModellingData.tableDetails[index].roundSize,
      currentValue: newModellingData.tableDetails[index].currentValue,
      cumulativeInvestment: newModellingData.tableDetails[index].cumulativeInvestment,
      isHoldingPercentageModified: newModellingData.tableDetails[index].isHoldingPercentageModified,
    }));

    const updatedModellingData: ExitModellingDataModel = {
      ...newModellingData,
      tableDetails: newTableDetails,
    }

    return updatedModellingData;
  }
  return newModellingData;
}

const URL = process.env.REACT_APP_SOCKET_URL || 'ws://localhost:4000/'
let socket: Socket | null = null;

function connectSocket() {
  socket = io(URL, {
    extraHeaders: {
      accesstoken: sessionStorage.getItem('accessToken') || '-',
      companyId: sessionStorage.getItem('companyId') || '-',
    },
  })
  socket.connect()
}

const IMDataStore = create<IMState>((set: any) => ({
  ...exitModellinginitialState,
  setIMData: (data: any) => {
    set((state: any) => ({ IMData: data }))
  },
  connect: () => {
    if (!socket?.connected) {
      connectSocket();
    }
  },
  disconnect: () => {
    socket?.disconnect()
  },
  sendMessage: (message: any) => {
    if (!socket?.connected) {
      connectSocket();
    }

    socket?.emit('message', message)

    socket?.on('message', (data: any) => {
      const modellingData = JSON.parse(data) as ExitModellingDataModel;
      modellingData.tableDetails.forEach((table) => {
        table.isHoldingPercentageModified = true;
      });
      set((state: any) => ({ IMData: updateCalculatedValues(state.IMData, modellingData) }))
    })

    socket?.on("error", (data: any) => {
      console.log("error connecting socket", data);
    });
  },
  reset: (message: any) => {
    const discardData = {
      ...message,
      hasToDiscard: true,
    }
    socket?.emit('message', discardData)
    set(() => exitModellinginitialState)
  },
  resetData: () => {
    set(() => exitModellinginitialState)
  }
}))

export const useIMDataStore = IMDataStore
